import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Iframe from "react-iframe";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import SessionManager from "../Utils/SessionManager";
import axios from "axios";

/**
 * Old Due Payment Status dialog
 *
 * Props:
 * - show: boolean
 * - onClose: function
 * - transactionId: string
 * - studentId: string
 * - sessionId: string
 * - sessionName?: string
 * - collectedAmount?: number
 */
const MdlOldDuePaymentStatus = ({
  show = true,
  onClose,
  transactionId,
  studentId,
  sessionId,
  sessionName,
  collectedAmount,
}) => {
  const [modalShow, setModalShow] = useState(show);
  const [loadingReceipt, setLoadingReceipt] = useState(false);
  const [receiptUrl, setReceiptUrl] = useState("");
  const [receiptNo, setReceiptNo] = useState("");
  const [newReceiptNo, setNewReceiptNo] = useState("");
  const [updatingReceipt, setUpdatingReceipt] = useState(false);

  const [whatsappOption, setWhatsappOption] = useState("details"); // 'details' | 'receipt' | 'both'
  const [effectiveCollectedAmount, setEffectiveCollectedAmount] = useState(
    collectedAmount || 0
  );
  const [studentPhone, setStudentPhone] = useState("");

  useEffect(() => {
    setModalShow(show);
  }, [show]);

  // Fetch student contact details (for WhatsApp number)
  useEffect(() => {
    if (!studentId) return;

    const FUNCTION_NAME = "getStudentContactDetails.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          student_id: studentId,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK" && Array.isArray(response.data)) {
          const first = response.data[0];
          const raw = first?.contact_number || "";
          const digits = (raw || "").replace(/\D/g, "");
          // If 10-digit Indian mobile, prefix +91
          const withCountry =
            digits.length === 10 ? `91${digits}` : digits || "";
          setStudentPhone(withCountry);
        } else if (response.api_remark) {
          console.log("getStudentContactDetails remark:", response.api_remark);
        }
      })
      .catch((error) => {
        console.error("getStudentContactDetails error:", error);
      });
  }, [studentId]);
  // Fetch Old Due payment details (including receipt no and line items)
  useEffect(() => {
    if (!transactionId) return;

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    if (!SCHOOL_CODE) return;

    const FUNCTION_NAME = "getOldDuePaymentDetails.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          transaction_id: transactionId,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK" && response.data?.length > 0) {
          const payload = response.data[0];
          if (payload.receipt_no) {
            setReceiptNo(payload.receipt_no);
            setNewReceiptNo(payload.receipt_no);
          }
          const items = payload.payment_details || [];
          if (!collectedAmount && items.length > 0) {
            const total = items.reduce(
              (sum, item) => sum + (Number(item.amount_paid) || 0),
              0
            );
            setEffectiveCollectedAmount(total);
          }
        } else if (response.api_remark) {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        console.error("getOldDuePaymentDetails error:", error);
      });
  }, [transactionId, collectedAmount]);

  // Build Old Due Fee Receipt URL (iframe)
  useEffect(() => {
    if (!transactionId || !studentId || !sessionId) return;

    const schoolCode = SessionManager.getSchoolCode();
    const FileName = "FeeReceipt/old_due_fee_receipt_sample1.php?";
    const baseUrl =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR_PRINTABLE +
      FileName;

    // For sharing/preview we hide school copy explicitly
    const url =
      baseUrl +
      `&student_id=${encodeURIComponent(studentId)}` +
      `&session_id=${encodeURIComponent(sessionId)}` +
      `&transaction_id=${encodeURIComponent(transactionId)}` +
      `&system_code=${encodeURIComponent(
        process.env.REACT_APP_SYSTEM_CODE || ""
      )}` +
      `&school_code=${encodeURIComponent(schoolCode || "")}` +
      `&SchoolCopy=0`;

    setLoadingReceipt(true);
    setReceiptUrl(url);
  }, [transactionId, studentId, sessionId]);

  const handleClose = () => {
    setModalShow(false);
    if (onClose) {
      onClose();
    }
  };

  const handleUpdateReceiptNo = () => {
    const trimmed = (newReceiptNo || "").trim();
    if (!trimmed) {
      myToast.notify_warning("Please enter a valid receipt number");
      return;
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const staffData = SessionManager.getStaffDetails();
    const STAFF_ID = staffData?.staff_id || "";

    if (!SCHOOL_CODE || !STAFF_ID) {
      myToast.notify_error("Missing staff or school information");
      return;
    }

    setUpdatingReceipt(true);

    const FUNCTION_NAME = "updateReceiptNo.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const formData = new URLSearchParams();
    formData.append("staff_id", STAFF_ID);
    formData.append("school_code", SCHOOL_CODE);
    formData.append("transaction_id", transactionId || "");
    // Backend ignores old receipt_no field in UPDATE, but it is required
    formData.append("receipt_no", receiptNo || "");
    formData.append("receipt_no_new", trimmed);

    axios
      .post(URL, formData)
      .then((res) => res.data)
      .then((response) => {
        setUpdatingReceipt(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Receipt number updated successfully");
          setReceiptNo(trimmed);
        } else {
          myToast.notify_warning(
            response.api_remark || "Failed to update receipt number"
          );
        }
      })
      .catch((error) => {
        setUpdatingReceipt(false);
        console.error("updateReceiptNo error:", error);
        myToast.notify_error("Error updating receipt number");
      });
  };

  const buildCollectionDetailsText = () => {
    const parts = [];
    if (sessionName) {
      parts.push(`Session: ${sessionName}`);
    }
    if (studentId) {
      parts.push(`Student ID: ${studentId}`);
    }
    if (transactionId) {
      parts.push(`Txn: ${transactionId}`);
    }
    if (typeof effectiveCollectedAmount === "number") {
      parts.push(`Collected: ₹${effectiveCollectedAmount.toLocaleString()}`);
    }
    if (receiptNo) {
      parts.push(`Receipt No: ${receiptNo}`);
    }

    return `Old Due Fee Collection\n${parts.join("\n")}`;
  };

  const buildReceiptLinkText = () => {
    if (!receiptUrl) return "";
    return `Old Due Fee Receipt:\n${receiptUrl}`;
  };

  const handleWhatsAppShare = (type) => {
    let text = "";

    if (type === "details") {
      text = buildCollectionDetailsText();
    } else if (type === "receipt") {
      text = buildReceiptLinkText();
    } else if (type === "both") {
      const details = buildCollectionDetailsText();
      const receipt = buildReceiptLinkText();
      text = [details, receipt].filter(Boolean).join("\n\n");
    }

    if (!text) {
      myToast.notify_warning("Nothing to share");
      return;
    }

    const base = studentPhone ? `https://wa.me/${studentPhone}` : `https://wa.me/`;
    const separator = base.includes("?") ? "&" : "?";
    const shareUrl = `${base}${separator}text=${encodeURIComponent(text)}`;
    window.open(shareUrl, "_blank");
  };

  return (
    <Modal
      show={modalShow}
      onHide={handleClose}
      animation={false}
      size="xl"
      aria-labelledby="old-due-payment-status-title"
      centered
      dialogClassName="old-due-payment-modal"
      style={{ opacity: 1 }}
    >
      <Modal.Header
        closeButton
        style={{
          background: COLORS.primary_color_shade7,
          color: COLORS.white,
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
        }}
      >
        <Modal.Title
          id="old-due-payment-status-title"
          style={{ fontWeight: 700, fontSize: "18px" }}
        >
          Old Due Payment Status
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "16px 20px" }}>
        {/* Compact success header */}
        <div
          className="row"
          style={{ alignItems: "center", marginBottom: 8 }}
        >
          <div
            className="col-sm-1 col-md-1 gravity_center"
            style={{ minWidth: 40 }}
          >
            <i
              className="fa fa-check-circle"
              style={{ fontSize: 32, color: COLORS.green4 || "#2C8D02" }}
            />
          </div>
          <div className="col-sm-11 col-md-11">
            <h5
              className="text-success"
              style={{ fontWeight: 600, margin: 0 }}
            >
              Collection Submitted Successfully
            </h5>
          </div>
        </div>

        {/* Collection summary (single line, aligned under header text) */}
        <div className="row" style={{ marginBottom: 8 }}>
          <div className="col-sm-1 col-md-1" />
          <div className="col-sm-11 col-md-11">
            <div style={{ fontSize: 14, color: COLORS.black7 || "#444" }}>
              <strong>Txn:</strong> {transactionId || "-"}{" "}
              <span
                style={{ margin: "0 8px", color: COLORS.black5 || "#777" }}
              >
                |
              </span>
              <strong>Collected:</strong>{" "}
              <span style={{ fontWeight: 700 }}>
                ₹{(effectiveCollectedAmount || 0).toLocaleString()}
              </span>
            </div>
          </div>
        </div>

        {/* Receipt number edit */}
        <div className="row" style={{ marginBottom: 12 }}>
          <div className="col-md-12">
            <label
              style={{
                display: "block",
                marginBottom: 6,
                fontSize: 14,
                fontWeight: 600,
                color: COLORS.black8 || "#333333",
              }}
            >
              <i
                className="fa fa-receipt"
                style={{
                  marginRight: 6,
                  color: COLORS.primary_color_shade6,
                }}
              />
              Receipt Number (editable)
            </label>
            <div className="input-group admission_form2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter new receipt number"
                value={newReceiptNo}
                onChange={(e) => setNewReceiptNo(e.target.value)}
              />
              <div className="input-group-append">
                <Button
                  variant="primary"
                  onClick={handleUpdateReceiptNo}
                  disabled={updatingReceipt}
                  style={{
                    background: COLORS.primary_color_shade6 || "#039BE5",
                    borderColor: COLORS.primary_color_shade6 || "#039BE5",
                  }}
                >
                  {updatingReceipt ? "Updating..." : "Update"}
                </Button>
              </div>
            </div>
            {receiptNo && (
              <div
                style={{
                  marginTop: 6,
                  fontSize: 12,
                  color: COLORS.black5 || "#7f7f7f",
                }}
              >
                Current Receipt No: <strong>{receiptNo}</strong>
              </div>
            )}
          </div>
        </div>

        {/* WhatsApp options - Hidden */}
        {false && (
          <div className="row" style={{ marginBottom: 8 }}>
            <div className="col-md-12">
              <h6 style={{ marginBottom: 6 }}>
                <i
                  className="fa fa-whatsapp"
                  style={{
                    marginRight: 6,
                    color: "#25D366",
                  }}
                />
                WhatsApp Share
              </h6>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 8,
                }}
              >
                <button
                  type="button"
                  onClick={() => {
                    setWhatsappOption("details");
                    handleWhatsAppShare("details");
                  }}
                  className="btn btn-success"
                  style={{
                    backgroundColor: "#25D366",
                    borderColor: "#25D366",
                    minWidth: 160,
                  }}
                >
                  Collection Details
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setWhatsappOption("receipt");
                    handleWhatsAppShare("receipt");
                  }}
                  className="btn btn-success"
                  style={{
                    backgroundColor: "#25D366",
                    borderColor: "#25D366",
                    minWidth: 160,
                  }}
                >
                  Receipt In Pdf
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setWhatsappOption("both");
                    handleWhatsAppShare("both");
                  }}
                  className="btn btn-success"
                  style={{
                    backgroundColor: "#25D366",
                    borderColor: "#25D366",
                    minWidth: 160,
                  }}
                >
                  Details + Receipt
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Fee receipt iframe */}
        <div className="row" style={{ marginBottom: 12 }}>
              <div className="col-md-12">
            <h6 style={{ marginBottom: 6 }}>Fee Receipt Preview</h6>
            <div
              className="bg_card_primary_outline"
              style={{ minHeight: 300, padding: 4 }}
            >
              {loadingReceipt && (
                <div className="gravity_center" style={{ padding: 16 }}>
                  <span>Loading receipt...</span>
                </div>
              )}
              {receiptUrl && (
                <Iframe
                  url={receiptUrl}
                  width="100%"
                  height="900px"  // Approx full A4 height on screen
                  display="initial"
                  position="relative"
                  scrolling="no"
                  frameBorder="0"
                  style={{ border: "none", overflow: "hidden" }}
                  onLoad={() => setLoadingReceipt(false)}
                  className="bg_card_primary_outline"
                />
              )}
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
          style={{ minWidth: 120 }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlOldDuePaymentStatus;


